import { render, staticRenderFns } from "./PriceListSelector.vue?vue&type=template&id=638dfefe"
import script from "./PriceListSelector.ts?vue&type=script&lang=ts&external"
export * from "./PriceListSelector.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports